module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popover-container"
  }, [_c('a', {
    staticClass: "ls-ico-help",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "mouseover": function($event) {
        $event.preventDefault();
        _vm.showPopover($event)
      },
      "mouseout": function($event) {
        $event.preventDefault();
        _vm.hidePopover($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ls-popover",
    class: _vm.className
  }, [_c('div', {
    staticClass: "ls-popover-content"
  }, [_vm._t("content")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a1dbaa8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/shareds/popover/Popover.vue
// module id = 796
// module chunks = 1